import { useCallback } from "react";
import { axiosService } from "network/axios";
import { getLoggedInUser } from "network/helper";

export function useBusinessAutologin() {
  const autologin = useCallback(
    async (userId: string | null) => {
      if (!userId) {
        return { success: false as const, error: "Missing user id." };
      }

      try {
        const payload = { user_id: Number(userId) };
        const res = await axiosService.post("/autologin", payload);
        const { access_token } = res?.data as any;
        const user = getLoggedInUser(access_token);
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("user_details", JSON.stringify(user));
        localStorage.removeItem("order_status");
        return { success: true as const };
      } catch (err: any) {
        const error =
          err?.data?.messages?.error ||
          err?.response?.data?.messages?.error ||
          "Auto-login failed. Please login manually.";
        return { success: false as const, error };
      }
    },
    []
  );

  return { autologin };
}
